import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  Button,
} from '@mui/material';
import { useUntypedTranslation } from '../../hooks/useUntypedTranslation';

interface MessageDeleteDialogProps {
  open: boolean;
  onClose: () => void;
  onConfirm: () => void;
  messageCount: number;
}

/**
 * Confirmation dialog for message deletion.
 */
const MessageDeleteDialog: React.FC<MessageDeleteDialogProps> = ({
  open,
  onClose,
  onConfirm,
  messageCount
}) => {
  const { t } = useUntypedTranslation();
  
  return (
    <Dialog
      open={open}
      onClose={onClose}
      aria-labelledby="delete-dialog-title"
      aria-describedby="delete-dialog-description"
    >
      <DialogTitle id="delete-dialog-title">
        {t('messageActions.deleteMessageTitle')}
      </DialogTitle>
      <DialogContent>
        <DialogContentText id="delete-dialog-description" component="div">
          {messageCount === 1 
            ? t('messageActions.deleteMessageSingle')
            : t('messageActions.deleteMessageMultiple').replace('{count}', String(messageCount - 1))
          }
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} color="primary">
          {t('history.cancel')}
        </Button>
        <Button onClick={onConfirm} color="error" autoFocus>
          {t('history.delete')}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default MessageDeleteDialog; 